// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zTr8","left":"styles_left__2AYUt"};